__turbopack_context__.v({
  "premiumBadge": "OrganizerNameWithBadge-module-scss-module__e5OyYW__premiumBadge",
  "premiumNameEnd": "OrganizerNameWithBadge-module-scss-module__e5OyYW__premiumNameEnd",
  "premiumTooltip": "OrganizerNameWithBadge-module-scss-module__e5OyYW__premiumTooltip",
});
